<base-sidenav
  (onClose)="close()"
  (onClear)="clear()"
  (onValidate)="validate()"
  [standardForms]="standardForms"
></base-sidenav>

<ng-template #standardForms>
  <form [formGroup]="getFormGroup('standardForm')">
    <base-form-input
      label="Identifiant technique"
      [withoutPadding]="true"
      appearance="outline"
      controlName="technicalIdentifier"
    ></base-form-input>

    <base-form-input
      label="Réf. Fournisseur"
      [withoutPadding]="true"
      appearance="outline"
      controlName="reference"
    ></base-form-input>

    <base-form-input
      (autocompleteChange)="autocompleteSuppliers($event)"
      [items$]="getItems$('suppliers')"
      (onScroll)="onScrollLine($event, 'suppliers')"
      appearance="outline"
      controlName="suppliers"
      displayProperty="label"
      label="Fournisseur"
      type="search-multiple"
      [withoutPadding]="true"
    ></base-form-input>

    <base-form-input
      (autocompleteChange)="autocompleteGenericProducts($event)"
      [items$]="getItems$('genericProducts')"
      (onScroll)="onScrollLine($event, 'genericProducts')"
      appearance="outline"
      controlName="genericProducts"
      displayProperty="label"
      label="Article générique"
      type="search-multiple"
      [withoutPadding]="true"
    ></base-form-input>

    <base-form-input
      *ngFor="let distinctFilter of distinctFilters"
      (autocompleteChange)="autocompleteProductsFields($event, distinctFilter.field)"
      [items$]="getItems$(distinctFilter.field)"
      (onScroll)="onScrollLine($event, distinctFilter.field)"
      [label]="distinctFilter.label"
      [withoutPadding]="true"
      appearance="outline"
      [displayProperty]="distinctFilter.field"
      [controlName]="distinctFilter.control"
      type="search-multiple"
    ></base-form-input>

    <!--        ></base-form-input>-->

    <base-form-input
      [items]="suspensionOptions"
      label="Suspension e-Shop"
      displayProperty="label"
      appearance="outline"
      type="select"
      controlName="isSuspended"
    ></base-form-input>
  </form>
</ng-template>
